v3v4CssClassRun.$inject = ['$rootElement', '$rootScope'];
export function v3v4CssClassRun($rootElement, $rootScope) {

  // Add a CSS class on the html element that depends on
  // whether the current page content is v3 (bootstrap)
  // or v4 (fuse material theme)
  //
  // As of the task process page migration to Angular,
  // the TaskProcessWrapperController will remove the alc-v3-content class, as an exception
  // (at the moment it feels like too much of a pain to get rid of the convention
  //  that the task process state name is the tasks list state + '.process')
  $rootScope.$on('$stateChangeSuccess',
    function (event, toState, toParams, fromState, fromParams) {
      const exceptionWithFuseCssStyle = ['auth.alcmeon.engagement.history']
      if (exceptionWithFuseCssStyle.includes(toState.name) || toState.name.indexOf('.fuse.') != -1 || toState.name.indexOf('fuse-') != -1) {
        $rootElement.removeClass('alc-angular-task-process-page');
        $rootElement.removeClass('alc-v3-content');
        $rootElement.addClass('alc-fuse-content');
      } else {
        $rootElement.removeClass('alc-angular-task-process-page'); // TaskProcessWrapperController will re-add it if we are transitionning to the task process page
        $rootElement.addClass('alc-v3-content');
        $rootElement.removeClass('alc-fuse-content');
      }
    });

}
